import { NotFoundException } from "../customExceptions";
import Loader from "@material-ui/core/CircularProgress";
import trimString from "../helpers/trimString";
import { useGetInterestGroup } from "../queries/interestGroups";
import { ENTITY } from "../constants";

export const InterestGroupBreadcrumb = ({ match }) => {
    // Entity
    const { INTERESTGROUP } = ENTITY;

  const {
    data: interestGroup,
    isLoading,
    isError,
    error,
  } = useGetInterestGroup(match.params.interestGroupId);

  if (isLoading) {
    //return <span>Loading...</span>;
    return <Loader color="primary" size={18} sx={{ mr: 1 }} />;
  }

  if (isError && error instanceof NotFoundException) {
    return <span>Not found</span>;
  }

  if (interestGroup) {
    return <span>{trimString(interestGroup[INTERESTGROUP.nameField], 20)}</span>;
  }

  return null;
};
